export const OPENING_INVENTORY = 1;
export const DEMAND = 2;
export const PURCHASE_ORDER = 3;
export const GRN = 4;
export const GRN_INVOICE = 5;
export const ISSUANCE = 6;
export const SUB_RECIPE_PRODUCTION = 7;
export const TRANSFER = 8;
export const WASTAGE = 9;
export const ADJUSTMENT = 10;
export const PHYSICAL_STOCK = 11;
export const DIRECT_PURCHASE = 12;
export const RECEIVING = 13;
export const DISCARD = 14;
